export default __webpack_public_path__ + "static/card-setup-pix-eeb5bd8c7b464919cb3b62b14b298c5d.png";